export default __webpack_public_path__ + "static/media/022-seaweed.2f8bf559.svg";